<template>
<!--  <div class="get-coupon-btn" :style="`background-image:url(${images.bg_btn_1});`">-->
  <div class="get-coupon-btn" @click="clickButton">
    {{buttonText}}
  </div>
</template>

<script>
export default {
  name: "getCouponButton",
  props:{
    buttonText:{
      type:String,
      default:"立即领取",
    },
  },
  data(){
    const ossPath = this.ossPath;
    return {
      images:{
        bg_btn_1: ossPath + "/pages/home/coupon/bg_btn_1.png",
      },
    }
  },
  methods:{
    clickButton(){
      this.$emit("clickButton");
    },
  }
}
</script>

<style scoped lang="scss">
.get-coupon-btn{
  margin: 0 auto;
  width: 187px;
  height: 39px;
  line-height: 39px;
  text-align: center;
  cursor: pointer;
  letter-spacing: 1px;
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: bold;
  color: #FE0106;
  user-select: none;
}
//.get-coupon-btn{
//  background-size: auto 100%;
//  background-position: center;
//  background-repeat: no-repeat;
//}
.get-coupon-btn{
  background: linear-gradient(top, #FFEF93,#FFD945 71%,#FFE77E);
  border-radius: 18px;
  box-shadow: 0 2px 2px #FF6B25;
  position: relative;
  &:before{
    transition: 0.4s ease;
  }
  &:hover{
    &:before{
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(255,255,255,0.2);
      border-radius: inherit;
    }
  }
  &:active{
    &:before{
      background-color: rgba(0,0,0,0.1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// common/couponPopover/getCouponButton.vue